import { whyChooseData } from "@/mocks/homeData";

export default function WhyChooseSection() {
  return (
    <section id="why-choose" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="text-sm font-semibold text-primary-500 uppercase tracking-wider">
            Our Difference
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mt-2 mb-4">
            {whyChooseData.headline}
          </h2>
          <p className="text-foreground-700 leading-relaxed">
            {whyChooseData.subheadline}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {whyChooseData.reasons.map((reason) => (
            <div
              key={reason.title}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300 transition-all"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                <i className={`${reason.icon} text-xl md:text-2xl text-primary-500`} />
              </div>
              <h4 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-2">
                {reason.title}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}